import { Outlet } from 'react-router-dom';

export default function QSetReviewTaskLayout() {
  return <Outlet />;
}
